import Bugsnag, { type NotifiableError } from '@bugsnag/js'
import clickOutsideDirective from '@ds/directives/clickOutsideDirective'
import tooltipDirective from '@ds/directives/tooltipDirective'
import bugsnagPlugin from '@vuejs/plugins/bugsnag'
import { useFeatureFlagStore } from '@vuejs/stores/FeatureFlagStore'
import { setupGlobalMessageHandler } from '@vuejs/utils/messageHandler'
import { createPinia } from 'pinia'
import { type Component, createApp } from 'vue'

export function createVueApp(rootComponent: Component) {
	const pinia = createPinia()
	const app = createApp(rootComponent)

	setupGlobalMessageHandler()

	app.use(pinia)

	bugsnagPlugin(app)

	const featureFlagStore = useFeatureFlagStore()

	featureFlagStore.loadFeatureFlags()

	app.directive('clickOutside', clickOutsideDirective)
	app.directive('tooltip', tooltipDirective)

	// Global error handler for chunk loading failures
	app.config.errorHandler = (error, _instance, info) => {
		if (error instanceof Error && error.message.includes('Failed to fetch dynamically imported module')) {
			console.info(`${info}: New version detected. Reloading page...`)
			window.location.reload()

			return
		}

		Bugsnag.notify(error as NotifiableError)
		console.error("Uncaught error:", error)
	}

	// Catch unhandled promise rejections for chunk loading failures
	window.addEventListener('unhandledrejection', event => {
		const message = event.reason?.message

		if (typeof message !== 'string') return

		if (message.includes('Failed to fetch dynamically imported module')) {
			window.location.reload()

			return
		}

		if (message.includes('Failed to fetch')) {
			event.preventDefault()

			return
		}
	})

	return app
}
